import script from "./WelcomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomePage.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomePage.vue?vue&type=style&index=0&id=922cb800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-922cb800"]])

export default __exports__